<script>
    import utilsService from '@/services/core/utils.service';

    export default {
        props: {
            modelValue: Boolean,
            disabled: Boolean,
            switch: Boolean,
            id: String,
            stopPropagation: Boolean,
            inputClass: String,
            inputStyle: String,
            labelClass: String,
            labelStyle: String
        },
        emits: ['update:modelValue', 'change', 'click'],
        computed: {
            guid() {
                return this.id || `form-checkbox-${utilsService.uuid()}`;
            },
            isSwicth() {
                return this.switch === true;
            }
        },
        methods: {
            onChange(e) {
                const { checked } = e.target || {};
                this.$emit('update:modelValue', checked);
                this.$nextTick(() => this.$emit('change', checked));
            },
            onClick(e) {
                if (this.stopPropagation) e.stopPropagation();
                else this.$emit('click');
            }
        }
    };
</script>

<template>
    <div class="gsb-form-checkbox" :class="[isSwicth ? 'form-switch' : 'form-check', { disabled: disabled }]" @click.stop>
        <input
            type="checkbox"
            class="form-check-input"
            :id="guid"
            :checked="modelValue"
            :disabled="disabled"
            :class="inputClass"
            :style="inputStyle"
            @change="e => onChange(e)"
            @click="e => onClick(e)"
        />

        <label class="form-check-label" :for="guid" :class="labelClass" :style="labelStyle" @click="e => onClick(e)">
            <slot />
        </label>
    </div>
</template>

<style lang="scss">
    .gsb-form-checkbox {
        &.form-check {
            .form-check-input,
            .form-check-label {
                margin-top: 0;
            }

            .form-check-input {
                float: none;
                height: 1.3rem;
                width: 1.3rem;
                margin-right: 0.5rem;
            }
        }

        &.form-switch {
            .form-check-input {
                cursor: pointer;
                margin-right: 0.25rem;
            }
        }

        &:not(.disabled) {
            .form-check-label {
                cursor: pointer;
            }
        }

        &.disabled {
            opacity: 0.75;

            .form-check-label {
                color: var(--bs-gray-600);

                &,
                &::before,
                &::after {
                    cursor: default;
                }
            }
        }
    }
</style>
